<script lang="ts" setup>
import { Vue3Lottie } from 'vue3-lottie'
import { useI18n } from 'vue-i18n';
import { buildMeta } from '~~/utils/meta-builder';
import json from "@/assets/smoxy_powers_2.json";
import checkAnim from "@/assets/check.json";
useHead(buildMeta({ key:'contact',  follow: false }))   
const localePath = useLocalePath()
const i18n = useI18n()
// TODO refactor this!
const path = localePath('help')
const helpCenter = `<a class="nav-link font-normal text-secondary-500 text-xl hover:text-secondary-400" href="${path}">${i18n.t('help.headline')}</a>`
const hideForm = ref(false)
const isSending = ref(false)
const message = ref("")
const name = ref("")
const email = ref("")
const route = useRoute()

const formSubmit = () => {
	formRequest().then( (result) => {
		console.log(result)
	}).catch( (error) => {
			console.error('Contact form could not be send', error)
	});
}

const formRequest = async() => {
	if(isSending.value)return
	isSending.value = true;
	try{
			const result = await $fetch( 'https://us-central1-smoxy-app.cloudfunctions.net/api/contact', { 
					method: 'POST',
					params: {
							'message': message.value,
							'name': name.value,
							'email': email.value,
							'from': "web_contact_form",
							'subjectType': route.params.subject || 'unknown',
					}
			} );

			console.log("on send success:", result)
			isSending.value = false;

			if((result as any).success){
					hideForm.value = true;
					message.value = ''    
					name.value = ''    
					email.value = ''  
			}else{
					hideForm.value = false;
			}
	}catch(e){
			isSending.value = false;
			console.error(e)
	}        
}

</script>

<template>
    <div class="bg-[#250f52]">
    <div class="w-full relative ">
        <!-- <div class="w-full h-full absolute -z-10">
            <div class="header w-full h-full">
              <svg class="absolute right-0" width="688" height="780" viewBox="0 0 688 780" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112467)">
                <circle cx="522.5" cy="257.5" r="278.5" fill="#FFA5A5" fill-opacity="0.79"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112467" x="0" y="-265" width="1045" height="1045" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="122" result="effect1_foregroundBlur_14818_112467"/>
                </filter>
                </defs>
              </svg>

               <svg class="absolute" width="377" height="565" viewBox="0 0 377 565" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112466)">
                <circle cx="9" cy="197" r="194" fill="#B5FBFF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112466" x="-359" y="-171" width="736" height="736" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="87" result="effect1_foregroundBlur_14818_112466"/>
                </filter>
                </defs>
              </svg>

              <svg class="mx-auto" width="1131" height="612" viewBox="0 0 1131 612" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_f_14818_112468)">
                <circle cx="590" cy="22" r="206" fill="#A864FF"/>
                </g>
                <defs>
                <filter id="filter0_f_14818_112468" x="0" y="-568" width="1180" height="1180" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="192" result="effect1_foregroundBlur_14818_112468"/>
                </filter>
                </defs>
              </svg>

            </div>
        </div> -->
       

        <div class="absolute top-[35%] md:top-auto h-full w-full z-0 md:-translate-x-1/4 overflow-hidden">
					 <ClientOnly> 
            <Vue3Lottie
                alt=""
                class="scale-[150%] md:scale-100 -translate-x-[15%] md:translate-x-0"       
                :loop="true"
                :auto-play="true"
                :animationData="json" 
                />
					 </ClientOnly> 
        </div> 

        <Header class="relative" theme="dark" />
    
        <div class="relative grid grid-cols-1 lg:grid-cols-2 max-w-screen-xl gap-0 px-10 lg:px-10 pt-10 pb-36 mx-auto items-center justify-center">
          
            <!-- <div class="flex flex-col text-center lg:text-left pb-10">
                <h1 class="text-3xl lg:text-[3.5rem] leading-[3.2rem] uppercase mx-auto lg:mx-0 text-[#290B50] font-gothic font-bold pb-6 pt-2">{{$t('contact.headline')}}</h1> 
               
            </div> -->

            <div class="relative col-span-1 pr-10">
                 <h1 class="text-4xl md:text-5xl lg:text-[3.5rem] lg:leading-[3.2rem] uppercase mx-auto lg:mx-0 text-white font-gothic font-bold pb-6 pt-2">{{$t('contact.headline')}}</h1> 
                <p class="text-gray-300 text-xl font-light pb-6" v-html="$t('contact.body', {'help_center': helpCenter})"></p>
            </div>

            <form @submit.prevent="formSubmit" class="flex flex-col mx-auto gap-6 w-full lg:pl-10" :class="{'hidden': hideForm, 'enabled': !isSending}">
                
                <div class="col-span-1">
                    <label for="name" class="leading-7 text-sm text-gray-300">{{$t('contact.form.name')}}</label>
                    <input type="text" id="name" name="name" v-model="name" class="backdrop-blur-md w-full bg-gray-100/30 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-white focus:text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out">
                </div>
                <div class="col-span-1">
                    <label for="email" class="leading-7 text-sm text-gray-300">{{$t('contact.form.email')}}</label>
                    <input type="email" id="email" name="email" v-model="email" class="backdrop-blur-md w-full bg-gray-100/30 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 text-base outline-none text-white focus:text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out">
                </div>
                <div class="col-span-2">
                    <label for="message" class="leading-7 text-sm text-gray-300">{{$t('contact.form.message')}}</label>
                    <textarea id="message" name="message" v-model="message" class="backdrop-blur-md w-full bg-gray-100/30 bg-opacity-50 rounded border border-gray-300 focus:border-indigo-500 focus:bg-white focus:ring-2 focus:ring-indigo-200 h-32 text-base outline-none text-white focus:text-gray-700 py-1 px-3 resize-none leading-6 transition-colors duration-200 ease-in-out"></textarea>
                </div>
                <button class="flex justify-center w-full btn-primary">
                    <div role="status" :class="{'hidden': !isSending}">
                        <svg class="inline mr-2 w-8 h-8 text-black animate-spin fill-white" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                        </svg>
                        <span class="sr-only">Loading...</span>
                    </div>
                    <p class="h-8" :class="{'hidden': isSending}">{{$t('contact.form.action')}}</p>
                </button>

            </form>

            <div class="w-full flex flex-col justify-center" :class="{'hidden': !hideForm}">
							<ClientOnly>
                <Vue3Lottie
                    alt="Check icon animation"
                    class="relative w-32 h-32 mx-auto"
                    :loop="false"
                    :auto-play="false"
                    :pause-animation="!hideForm"
                    :animationData="checkAnim" /> 
							</ClientOnly>
							<transition
									enter-active-class="duration-500 ease-out delay-700"
									enter-from-class="transition opacity-0 scale-75"
									enter-to-class="opacity-100 scale-100" >
									<p v-if="hideForm" class="mx-auto text-white/50 text-xl">{{$t('contact.form.success')}}</p>  
							</transition>    
            </div>

        </div>

        

    </div> 
   
    <Footer class="relative" theme="dark" />
  </div>
</template>